module.exports = __webpack_public_path__ + "img/logo.e823f6dc.png";